import { Location } from '@angular/common';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/takeWhile';

import { MetaService } from './meta.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.min.css'],
})
export class AppComponent implements OnDestroy, OnInit {
    @HostBinding('class.closed') public closed = true;

    private alive = true;
    private routeChangeTriggeredByHistory = false;

    public constructor(private router: Router,
                       private location: Location,
                       private metaService: MetaService) {
    }

    public ngOnDestroy(): void {
        this.alive = false;
    }

    public ngOnInit(): void {
        this.location.subscribe(() => this.routeChangeTriggeredByHistory = true);

        const navigationEndEvents = this.router.events
            .filter((event) => event instanceof NavigationEnd);

        navigationEndEvents
            .takeWhile(() => this.alive)
            .subscribe(e => {
                if (!this.routeChangeTriggeredByHistory) {
                    window.scrollTo(0, 0);
                    this.setNavVisibility(false);
                }
                this.routeChangeTriggeredByHistory = false;
                this.metaService.resetMetaSettings();
                this.metaService.updateMetaSettings({
                    url: location.href,
                });
            });
    }

    public setNavVisibility(visible: boolean): void {
        this.closed = !visible;
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/app.component.ts